import styled from 'styled-components';

export const Title = styled('text')`
  ${({ theme }) => theme.typography.xSmallStrong}
  fill: ${({ theme, color }) => color || theme.color.white};
`;
